import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGuestAuth } from '@/common/contexts/GuestAuthContext';
import { useLanguageData } from '@/common/hooks/useLanguageData';
import { ORDER_STATUS_PHASE } from '../constants/orderStatus.constants';
import {
	buildRedirectDestination,
	applyPaymentError,
	redirectToRetryCheckout,
} from '../utils/orderStatusRedirect';

const useOrderStatusFailureRedirect = (params, phase, triggeredByTimeout) => {
	const navigate = useNavigate();
	const { openPlanPaywall } = useGuestAuth();
	const t = useLanguageData('chat');

	useEffect(() => {
		if (phase !== ORDER_STATUS_PHASE.FAILED || !triggeredByTimeout) {
			return;
		}

		const handleFailureRedirect = () => {
			const destination = buildRedirectDestination(params);

			if (params.fromQuiz) {
				if (params.checkoutReturnUrl) {
					window.location.replace(params.checkoutReturnUrl);
					return;
				}

				navigate(destination, { replace: true });
				return;
			}

			applyPaymentError({
				isTokenPayment: params.isTokenPayment,
				message: t.orderStatusPaymentTimeout,
				returnPath: params.returnPath,
				openPlanPaywall,
			});

			navigate(destination, { replace: true });
		};

		handleFailureRedirect();
	}, [navigate, params, phase, triggeredByTimeout, openPlanPaywall, t.orderStatusPaymentTimeout]);

	const handleRetryCheckout = useCallback(() => {
		applyPaymentError({
			isTokenPayment: params.isTokenPayment,
			message: t.orderStatusPaymentFailed,
			returnPath: params.returnPath,
			openPlanPaywall,
		});

		redirectToRetryCheckout({
			fromQuiz: params.fromQuiz,
			checkoutReturnUrl: params.checkoutReturnUrl,
			navigate,
		});
	}, [params, navigate, openPlanPaywall, t.orderStatusPaymentFailed]);

	return { handleRetryCheckout };
};

export default useOrderStatusFailureRedirect;
